import { loginAdmin } from 'pages/admin/_redux/actions';
import { accessTokenAdminSelector } from 'pages/admin/_redux/selectors';
import { resetAccessTokenClienteAction } from 'pages/cliente/_redux/actions';
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';


interface RouteParams {
  userToken: string
}

const LoginAdmin: React.FC = () => {

  const dispatch = useAppDispatch();
  const accessTokenAdmin = useAppSelector(accessTokenAdminSelector);
  const history = useHistory();
  const { userToken } = useParams<RouteParams>();

  useEffect(() => {
    // supponiamo di avere in querystring il parametro userToken, che consentirà all'operatore banca di effettuare l'autenticazione
    if (userToken) {
      // provo a fare login admin
      dispatch(resetAccessTokenClienteAction());
      dispatch(loginAdmin(userToken));
    } else {
      history.push(`/error-page`);
    }
  }, [history, dispatch, userToken]);


  useEffect(() => {
    if (accessTokenAdmin) {
      localStorage.setItem('accessTokenAdmin', accessTokenAdmin);
      // localStorage.removeItem('accessTokenCliente');
      history.push(`/admin/dashboard`);
    }
  }, [history, accessTokenAdmin]);

  return null;

}

export default LoginAdmin;



